import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import { useLocation, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import MantRegContact from "./components/MantRegContact.jsx";
import {useZonaAgencia} from "../../context/ZonaAgenciaContext.jsx";
const MySwal = withReactContent(Swal);

const PageRegContact = () => {
    const location = useLocation();

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    const [destinosCredito, setDestinosCredito] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [formasPago, setFormasPago] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [monedas, setMonedas] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [metodosPago, setMetodosPago] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [listSolicitudes, setListSolicitudes] = useState(CONFIGURACIONES.INIT.ARRAY);

    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();
    const { zona, agencia} = useZonaAgencia();

    const createSolicitud = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
       
        await Functions().save(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/registrar-contacto`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), searchData, form);
    };

    const loadData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/util/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDestinosCredito(rpta.data.destinosCredito);
                setFormasPago(rpta.data.formasPago);
                setMonedas(rpta.data.monedas);
                setMetodosPago(rpta.data.metodosPago);
            }
        });
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const searchData = () => {
        console.log('exec searchData');
        if (!zona || !agencia) { return; }

        showSpinnerLoader();
        let data = {
            body: {
                'agenciaId': agencia,
                'zonaId': zona,
                'usuarioRegistro': getUser().user,
            }
        }
        setListSolicitudes(CONFIGURACIONES.INIT.ARRAY);
        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/buscar`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setListSolicitudes(rpta.data);
            }
        });
    }

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        
        showSpinnerLoader();
        loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        // loadData();
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        // console.log('componentes', componentes);
        
    }, [location.pathname])


    useEffect(() => {
        searchData()
    }, [zona, agencia]);
    
    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantRegContact title={'Registro de Contacto'} idEdit={idRef} MySwal={MySwal} icon={iconActive}
                                        setIdRef={setIdRef} fnBuscar={searchData} fnCrear={createSolicitud} list={listSolicitudes}
                                        showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} destinosCredito={destinosCredito}
                                        showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)} user={getUser()} formasPago={formasPago}
                                        monedas={monedas} zona={zona} agencia={agencia} metodosPago={metodosPago}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                       
                </div>
            </div>
        </div>
    )
}

export default PageRegContact;